// CoursesForPersonnelDialog/index.js
import { connect } from 'react-redux';
import CoursesForPersonnelDialog from '../../components/CoursesForPersonnelDialog';

import {
  openCoursesForPersonnelDialog,
  getCoursesForPersonnelDispatch,
  openAddCourseRecordDialogDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  const coursesForPersonnel = state.personnel.coursesForPersonnel;

  return {
    openDialog: coursesForPersonnel.dialogOpen,
    personnel: coursesForPersonnel.selectedPersonnel,
    courses: coursesForPersonnel.items,
    isLoading: coursesForPersonnel.isLoading,
    openAddCourseRecordDialog: state.course.newRecord.openAddCourseRecordDialog
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenCoursesForPersonnelDialog: (open, personnel) => {
      dispatch(openCoursesForPersonnelDialog(open, personnel));
    },
    getCoursesForPersonnel: (personnelId) => {
      dispatch(getCoursesForPersonnelDispatch(personnelId));
    },
    onOpenAddCourseRecordDialog: (open, personnelId, source) => {
      dispatch(openAddCourseRecordDialogDispatch(open, personnelId, source));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoursesForPersonnelDialog);
